<template>
  <div class="dialog-wrapper">
    <el-dialog
      :visible.sync="isShow"
      width="980px"
      :close-on-click-modal="false"
      :before-close="handleBeforeClose"
    >
      <div class="dialog-title" slot="title">分配精英机构/基地</div>
      <div class="dialog-content-wrapper">
        <div class="select-wrapper">
          <div class="left">
            <!-- <el-select
              v-model="filterData.name"
              size="medium"
              class="filter-select"
              placeholder=""
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in selectOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> -->
          </div>
          <div class="right">
            <el-input
              v-model="filterData.key"
              clearable
              @keyup.enter.native="handleSearch"
              @change="handleSearchChange"
              size="medium"
              placeholder="请输入搜索内容"
            >
              <el-button
                slot="append"
                class="search-btn"
                @click="handleSearch"
                type="success"
                >搜 索</el-button
              >
            </el-input>
          </div>
        </div>
        <div class="table-wrapper">
          <div class="table">
            <div class="thead">
              <div class="tr">
                <div class="th check">
                  <strong>
                    全选
                    <el-checkbox v-model="checkedAll"></el-checkbox>
                  </strong>
                </div>
                <div class="th seq">
                  <strong>序号</strong>
                </div>
                <div class="th youthShortName">
                  <strong>单位名称</strong>
                </div>
                <div class="th stageApplyType">
                  <strong>申报类型</strong>
                </div>
                <div class="th address">
                  <strong>所属区域</strong>
                </div>
                <div class="th">
                  <strong>操作</strong>
                </div>
              </div>
            </div>
            <div class="h430" v-if="pageList.length && !isLoading">
              <vue-scroll :ops="ops">
                <div class="tbody">
                  <div
                    class="tr"
                    v-for="(item, index) in pageList"
                    :key="index"
                  >
                    <div class="td check">
                      <el-checkbox v-model="item.checked"></el-checkbox>
                    </div>
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td youthShortName">
                      <p :title="item.youthName">
                        {{ item.youthShortName }}
                      </p>
                    </div>
                    <div class="td stageApplyType">
                      {{ item.stageApplyType }}
                    </div>
                    <div class="td address">
                      {{ item.cityName }} {{ item.countyName }}
                    </div>
                    <div class="td">
                      <p>
                        <span
                          v-if="!item.checked"
                          class="btn suc"
                          @click="togglePerformanceStatus(item)"
                          >分配</span
                        >
                        <span
                          v-else
                          class="btn suc"
                          @click="togglePerformanceStatus(item)"
                          >取消分配</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
            <yioks-empty
              :h="'430px'"
              v-if="!isLoading && !pageList.length"
              :whiteBg="true"
              tips="暂时没有数据"
            ></yioks-empty>
            <div class="bottom-line"></div>
          </div>
        </div>

        <yioks-loading v-if="isLoading" />
      </div>
      <div slot="footer" class="footer-btns-big">
        <el-button type="primary" @click="handleDialogAction('confirm')"
          >确 定</el-button
        >
        <el-button type="danger" @click="handleDialogAction('cancel')"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getExportsForYouth, postExportToYouthGroup } from "@/api/export";

import { ops } from "@/utils/scrollIndialog";
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true,
      default: false,
    },
    stageUuid: {
      type: String,
      required: false,
      default: "",
    },
    expertUuid: {
      type: String,
      required: false,
      default: "",
    },
  },

  data() {
    return {
      ops,
      pageList: [],
      isLoading: false,
      filterData: {
        key: "",
      },
      selectOption: [{ label: "label", value: "value" }],
    };
  },

  computed: {
    checkedAll: {
      get() {
        if (this.pageList.length) {
          let res = true;
          const list = JSON.parse(JSON.stringify(this.pageList));
          list.forEach((item) => {
            if (!item.checked) {
              res = false;
            }
          });
          return res;
        } else {
          return false;
        }
      },
      set(val) {
        this.pageList.forEach((item) => {
          item.checked = val;
        });
      },
    },
  },

  mounted() {
    this.loadPageList();
  },

  methods: {
    handleBeforeClose() {
      console.log("handleBeforeClose");
      this.setDialogStatus(false);
    },

    setDialogStatus(flag) {
      this.$emit("update:isShow", flag);
    },

    handleDialogAction(flag) {
      if (flag == "confirm") {
        let postData = this.pageList.filter((item) => {
          return item.checked;
        });
        postData = postData.map((item) => {
          const { youthUuid } = item;
          return {
            expertUuid: this.expertUuid,
            youthUuid: youthUuid,
            stageUuid: this.stageUuid,
          };
        });
        if (postData.length) {
          postExportToYouthGroup(postData)
            .then((res) => {
              this.$emit("callback", true, true);
            })
            .catch((err) => {
              this.$emit("callback", true, false);
              console.error("err", err);
            });
        } else {
          this.$emit("callback", true, false);
        }
      } else if (flag == "cancel") {
        this.$emit("callback", false, true);
      }
    },

    togglePerformanceStatus(row) {
      row.checked = !row.checked;
    },

    loadPageList() {
      const paramsData = {
        ...this.filterData,
        expertUuid: this.expertUuid,
        stageUuid: this.stageUuid,
      };
      getExportsForYouth(paramsData)
        .then((res) => {
          this.pageList = res.map((item) => {
            return {
              ...item,
              checked: false,
            };
          });
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
    // 搜索
    handleSearch() {
      this.loadPageList();
    },
    handleSearchChange(val) {
      if (!val) {
        this.loadPageList();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/yioks_page_table'
@import '~@/assets/css/yioks_table'
.dialog-title
  color #606266
  font-weight 600
  font-size 1.3em
  border-bottom 1px solid #606266
  padding-bottom 5px
.dialog-content-wrapper
  height 480px
  .table-wrapper
    margin-right 20px
.h430
  height 430px
.bottom-line
  margin-right 20px
  border-bottom 1px solid #666
.select-wrapper
  margin-right 40px
  margin-bottom 10px
  display flex
  justify-content space-between
  .filter-select
    &+.filter-select
      margin-left 15px
.dialog-wrapper
  /deep/.el-dialog__body
    padding-top 10px
  /deep/.el-button--success
    background-color $green_color !important
    color #fff
._6
  flex none !important
  width 6%
.idNumber
  flex none !important
  width 17%
.check
  flex none !important
  width 7%
.seq
  flex none !important
  width 6%
.stageApplyType
  flex none !important
  width 10%
.youthShortName
  flex none !important
  width 30%
.address
  flex none !important
  width 20%
  p
    white-space nowrap
    overflow hidden
    text-overflow ellipsis
</style>
